// 应用模版
export default [
    {
        path: '/messaging',
        component: () => import('@/pages/Mobile/Chat/pages/Messaging.vue'),
        meta:{title:"对话"},
    },
    {
        path: '/dialogsettings',
        component: () => import('@/pages/Mobile/Chat/pages/DialogSettings.vue'),
        meta:{title:"对话设置"},
    },
]